import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Clearfix from 'components/elements/clearfix';
import IconRequired from 'components/elements/required-icon';
import FacilitySelect from 'components/elements/select-facility';
import { COLOR, STYLE } from 'config';
import slug from 'constants/slug';
// import dynamicRoleHOC from 'hoc/dynamicRole';
import PropTypes from 'prop-types';
import { createForm } from 'rc-form';
import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';
import HazardWasteReportForm from './HazarWasteReportForm';
import InfoFacility from './InfoFacility';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

export const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

// @dynamicRoleHOC()
class FacilityHazarWasteReportForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
    // facility: PropTypes.shape({
    //   _id: PropTypes.string,
    //   FacilityNameFull: PropTypes.string
    // })
  };

  constructor(props) {
    super(props);
    let isExtraInfo = _.result(
      this.props.initialValue,
      'collector.isHasCustomInfo',
      false
    );
    this.state = {
      isExtraInfo,
      DiaChiText: '',
      NganhNgheText: '',
    };
  }

  componentDidMount() {
    if (this.props.getRef) this.props.getRef(this);
  }

  setInitialValue = (keyPath, defaultValue) => {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  };

  setSelInitialValue = (keyPath, defaultValue, nameLabel) => {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }
    return defaultValue;
  };

  setInitValueFacility = (keyPath, defaultValue) => {
    const value = _.result(this.props.initialValue, keyPath, defaultValue);
    if (!value) return null;
    return {
      value: _.get(value, '_id'),
      label: _.get(value, 'FacilityNameFull'),
      obj: value,
    };
  };

  submit = () => {
    this.props.form.validateFields((error, value) => {
      value.facility = _.get(value.facility, 'value');
      value.PaymentStatus = _.get(value.PaymentStatus, 'value');
      value.collector = _.get(value.collector, 'value');

      // NOTE update
      value.CapLan = _.get(value.CapLan, 'value');
      value.NamThucHienBaoCao = _.get(value.NamThucHienBaoCao, 'value', null);
      value.DonViThuGom_CTCNTT = _.get(value.DonViThuGom_CTCNTT, 'value');
      value.DonViThuGom_CTCNNH = _.get(value.DonViThuGom_CTCNNH, 'value');

      if (!value.facility) return;
      if (error) return;
      this.props.handelSubmit(value);
    });
  };

  onChangeFacility = (obj) => {
    this.setState({
      DiaChiText: _.get(obj, 'Address1'),
      NganhNgheText: _.get(obj, 'sector.Name'),
    });
  };

  onInitValueFacility = (facility) => {
    this.props.form.setFieldsValue({
      facility,
    });
  };

  render() {
    const {
      form: { getFieldError },
    } = this.props;

    return (
      <div>
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Báo cáo chất thải nguy hại
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={() => {
                  this.submit();
                }}
                style={{color: COLOR.SUCCESS}}
              />
              <Clearfix width={8} />
              <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}>
                <Icon
                  icon={IconNames.DISABLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                />
              </Link>
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <FacilitySelect
              // isDisabled={this.props.facility ? true : false}
              isEdit={this.props.isEdit}
              // onInitValue={this.onInitValueFacility}
              hideLabel
              // _id={_.get(this.props, ['facility', '_id'], '')}
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.setInitValueFacility('facility', null),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn Tên cơ sở/dự án',
                    },
                  ],
                },
              }}
              // cbChangeFacility={this.onChangeFacility}
            />
            <ErrorContainer>
              {(getFieldError('facility') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <InfoFacility form={this.props.form} />
        <HazardWasteReportForm
          form={this.props.form}
          setInitialValue={this.setInitialValue}
        />
      </div>
    );
  }
}

export default createForm()(FacilityHazarWasteReportForm);



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportForm/index.js